export const CANONICAL_ZODIAC_ROOM_IDS = Object.freeze([
  'room:aries',
  'room:tauro',
  'room:geminis',
  'room:cancer',
  'room:leo',
  'room:virgo',
  'room:libra',
  'room:escorpio',
  'room:sagitario',
  'room:capricornio',
  'room:acuario',
  'room:piscis',
]);

export function zodiacRoomIdForSign(signName) {
  const slug = String(signName || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
  const room = `room:${slug}`;
  return CANONICAL_ZODIAC_ROOM_IDS.includes(room) ? room : '';
}

export function normalizeZodiacRoomCountSnapshot(snapshot) {
  const snapshotAt = Number(snapshot?.snapshotAt || 0);
  if (!Number.isFinite(snapshotAt) || snapshotAt <= 0 || !snapshot?.counts) return null;
  const counts = {};
  for (const room of CANONICAL_ZODIAC_ROOM_IDS) {
    if (!Object.prototype.hasOwnProperty.call(snapshot.counts, room)) return null;
    const count = Number(snapshot.counts[room]);
    counts[room] = Number.isFinite(count) && count >= 0 ? Math.floor(count) : 0;
  }
  return { counts, snapshotAt };
}

export function applyZodiacRoomCountSnapshot(current, snapshot) {
  const normalized = normalizeZodiacRoomCountSnapshot(snapshot);
  if (!normalized || normalized.snapshotAt < Number(current?.snapshotAt || 0)) return current;
  return normalized;
}
